module.exports = __webpack_public_path__ + "img/domain@2x.ee5bcde3.png";